export default __webpack_public_path__ + "static/media/logoProjector.0a41a345.png";